import styled from '@emotion/styled'
import { Box, Typography } from '@mui/material'
import { typography } from '@resiliatech/birdsong'

export const TaskWidgetContainer = styled(Box)`
  display: flex;
  flex-direction: column;
`
export const ContentWrapper = styled(Box)`
  display: flex;
  flex-direction: column;
`

export const HeaderAndButtonContainer = styled(Box)`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
`

export const ButtonContainer = styled(Box)`
  display: flex;
  justify-content: flex-end;
  flex-grow: 1;
`

export const HeaderContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 85%;
`

export const Header = styled(Box)`
  ${typography.up1.regularSerif}
`
export const Subheader = styled(Typography)`
  ${typography.baseline.regularSans}
`

export const Section = styled(Box)`
  margin: 10px;
`
export const TaskListContainer = styled(Box)`
  margin-top: 24px;
`
